import React, {Component} from 'react';
import '../global';
import { connect } from 'react-redux';
import { getEmailPreferences } from '../actions';
import Loading from '../../components/loading-component';

class NewsLetterPreferences extends Component {
	constructor(props) {
		super(props);
		this.newsletter_form = getMyAccountObj().newsletter_form;
    }

	componentWillMount() {
		this.props.getEmailPreferences();
	}
		
        render(){
			return(
				<div>
					{this.props.loading ? (
						<Loading width={'100%'} height={100} />
					) : (
						<div dangerouslySetInnerHTML={{ __html: this.props.emailPreferences.email_preferences }} />
					)}
				</div>
			);
        }

}

const mapStateToProps = (state) => ({   
	emailPreferences: state.emailPreferences,
	loading: state.loading,
});

export default connect(mapStateToProps, { getEmailPreferences })(NewsLetterPreferences);